import { gql } from 'Utils/apolloClient'

const ValidationDataFragment = gql`
  fragment validationData on Validations {
    id
    areGuestsRequired
    isRigRequired
    guests {
      additionalNotes
      adults{
        ageRange
        max
        min
      }
      children {
        ageRange
        max
        min
      }
      maxPeople
      extraVehicles {
        max
        min
      }
      pets {
        max
        min
      }
      useGuests
    }
    measureUnit
    resetGuests
    rig {
      slideouts {
        max
        min
      }
      type
      year {
        max
        min
      }
      length {
        max
        min
      }
      lengthOptions {
        label
        value
      }
      width {
        max
        min
      }
      widthOptions {
        label
        value
      }
    }
    useMetricUnits
  }`

export default ValidationDataFragment
